// MUI
import { Grid } from "@mui/material";

// Hooks
import useAggregationExtended from "@Layouts/components/Tables/DataSmartTable/aggregation/Aggregation";
import { useGridApiRef } from "@mui/x-data-grid-premium";

// Components
import TableLoader from "@Layouts/components/Skeletons/TableLoader";
import AdvisorPerformanceDataTable from "./AdvisorPerformanceDataTable";

// Types
import { IAdvisorPerformance } from "@/DataPages/types/advisorPerformance/model";
import { IAdvisorPerformanceFooterModel } from "@DataPages/components/ServiceOperations/Tabs/AdvisorPerformance/interfaces";

interface IAdvisorPerformanceDataTableProps {
	loading: boolean;
	data: IAdvisorPerformance[] | null;
	hasNextPage: boolean;
}

export default function AdvisorPerformanceTable(props: Readonly<IAdvisorPerformanceDataTableProps>) {
	const { data, loading = false, hasNextPage = false } = props;
	const apiRef = useGridApiRef();
	const aggregations = useAggregationExtended({
		selectedSum: {},
	});

	const footerModels: IAdvisorPerformanceFooterModel = {
		repairOrderCount: "repairOrderCountAggregation",
		customerPay: {
			labor: {
				amount: "sum",
				hours: "sum",
			},
			parts: {
				amount: "sum",
			},
		},
		warranty: {
			labor: {
				amount: "sum",
				hours: "sum",
			},
			parts: {
				amount: "sum",
			},
		},
		internal: {
			labor: {
				amount: "sum",
				hours: "sum",
			},
			parts: {
				amount: "sum",
			},
		},
		subletGross: "sum",
		discountAmount: "sum",
		totalGross: "sum",
	};

	if (loading) {
		return (
			<Grid className="my-[10px] mr-[30px] ml-[38px]">
				<TableLoader smallTitle toolbar />
			</Grid>
		);
	}

	return (
		<Grid container alignContent="flex-start" className="h-full">
			<Grid position="relative" item xs={12} height={600}>
				{
					<AdvisorPerformanceDataTable
						hasNextPage={hasNextPage}
						apiRef={apiRef}
						title="Advisor Performance"
						rows={data}
						aggregations={aggregations}
						footerModels={footerModels}
					/>
				}
			</Grid>
		</Grid>
	);
}
